import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./SyncErrorItem.module.css";
import Button from "shared/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import ViewErrorInfoModal from "../ViewErrorInfoModal";

const errors = {
  name: "First and Last Name",
  iboNum: "00000000",
  date: "11/18/2022",
  time: "12:01 AM",
  syncError: "This is where the errors whould display...",
};

/**
 * View component. Displays information about sync errors in the sync errors list.  

 */
export function SyncErrorItem({ errorInfo, onClick }) {
  const [errorSyncModalOpen, setErrorSyncModalOpen] = useState(false);

  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{errorInfo.name}</div>
      <div className={styles.gridItem}>{errorInfo.iboNum}</div>
      <div className={styles.gridItem}>{errorInfo.syncError}</div>
      <div className={styles.gridItem}>
        {errorInfo.date + " " + errorInfo.time}
      </div>
      <div className={styles.gridItem}>
        {errorInfo.status ? "Unresolved" : ""}
        <FontAwesomeIcon
          icon={faExclamationCircle}
          className={styles.exclamationIcon}
          onClick={() => setErrorSyncModalOpen(true)}
        />
      </div>

      <Button
        className={styles.button}
        onClick={() => setErrorSyncModalOpen(true)}
        size="tiny"
        children="Details"
      />

      <ViewErrorInfoModal
        isOpen={errorSyncModalOpen}
        errors={errors}
        onClose={() => setErrorSyncModalOpen(false)}
      />
    </div>
  );
}

SyncErrorItem.propTypes = {
  /**
   * Object with the members info.
   */
  errorInfo: PropTypes.shape({
    name: PropTypes.string,
    iboNum: PropTypes.string,
    syncError: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    status: PropTypes.bool,
  }),

  /**
   * 	Function called when details is clicked
   */
  onClick: PropTypes.func,
};
